import { createBrowserHistory } from 'history'

const history = createBrowserHistory()

history.listen((location, action) => {
  window.scroll(0, 0)
})

export { history }
